module.exports = __webpack_public_path__ + "img/reservation.a6ebee46.svg";